// K2-3073: what the checkout does with an iPay payment vuestorefront-api has
// just created.

// /payment/create answered a payment to go on with (any other body is a
// failure: a decline, a rejected order, or 401 client_outdated with code 400).
export function isPaymentCreated (res: any): boolean {
  return Boolean(res) && res.code === 200 && Boolean(res.result)
}

/**
 * True once the payment is on every order: vuestorefront-api recorded it itself
 * (recorded: true), or - for an older vuestorefront-api or when that failed -
 * every order's create-transaction call succeeded. record(order) must reject
 * on a non-2xx answer.
 */
export async function ensurePaymentRecorded (res: any, orders: any[], record: (order: any) => Promise<any>): Promise<boolean> {
  if (res && res.recorded === true) {
    return true
  }
  try {
    await Promise.all(orders.map(order => record(order)))
    return true
  } catch (err) {
    console.error('[ipay-payment] payment not recorded', err)
    return false
  }
}

/**
 * An unrecorded payment iPay already completed (pmt_status 5) may have taken
 * the money: 'pending' (being checked). Anything else was not charged yet - its
 * 3DS/OTP confirmation could not settle it without the record: 'failed'.
 */
export function unrecordedPaymentOutcome (result: any): 'pending' | 'failed' {
  return result && parseInt(result.pmt_status) === 5 ? 'pending' : 'failed'
}

// K2-3073: vuestorefront-api's answers for a charge that may already be taken
// (or is being taken): a double submit in progress, an unsettled earlier
// payment.
const PENDING_REASONS = ['payment_in_progress', 'payment_being_checked']

// The order is paid already: ms-api refused the charge (it owes nothing), or
// vuestorefront-api refunded a repeated payment of it at once.
const PAID_REASON = 'already_paid'

/**
 * What the checkout does with vuestorefront-api's /payment/create answer:
 * 'created' - go on with the payment; 'paid' - the order is already paid:
 * shown as paid, never as a failure; 'pending' - iPay may have it (202, no
 * or an unreadable answer, a 409 above): shown as being checked, never
 * reported as failed; 'failed' - nothing was charged.
 */
export function paymentCreateOutcome (res: any): 'created' | 'paid' | 'pending' | 'failed' {
  if (isPaymentCreated(res)) {
    return 'created'
  }
  if (res && typeof res === 'object' && res.code === 409 && res.reason === PAID_REASON) {
    return 'paid'
  }
  if (!res || typeof res !== 'object' || res.code === 202 || (res.code === 409 && PENDING_REASONS.includes(res.reason))) {
    return 'pending'
  }
  return 'failed'
}

// K2-3073: /checkout/payment/failed?pending=1 - vuestorefront-api's 3DS callback
// when the bank may have taken the payment: shown as being checked, no Pay button.
export function isPaymentPendingRoute (route: any): boolean {
  return Boolean(route && route.query && String(route.query.pending) === '1')
}
